// Utility functions for chat components

export function formatChatTime(ts) {
  if (!ts) return '';

  const isoish = String(ts).replace(' ', 'T');
  const d = new Date(isoish);
  if (Number.isNaN(d.getTime())) return '';

  const now = new Date();
  const sameYMD = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  if (sameYMD(d, now)) {
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  const yest = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  if (sameYMD(d, yest)) {
    return 'Ayer';
  }

  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
}

export function formatMessageTimestamp(ts) {
  if (!ts) return '';

  const isoish = String(ts).replace(' ', 'T');
  const d = new Date(isoish);
  if (Number.isNaN(d.getTime())) return '';

  const now = new Date();
  const sameYMD = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  if (sameYMD(d, now)) return time;

  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  if (sameYMD(d, yesterday)) return `Ayer ${time}`;

  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${time}`;
}

const AUDIO_MIME_BY_EXT = {
  '.ogg': 'audio/ogg',
  '.opus': 'audio/ogg; codecs=opus',
  '.mp3': 'audio/mpeg',
  '.m4a': 'audio/mp4',
  '.aac': 'audio/aac',
  '.wav': 'audio/wav',
  '.amr': 'audio/amr',
};

const IMAGE_EXTS = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];

function getExt(url = '') {
  try {
    const u = new URL(url);
    const path = (u.pathname || '').toLowerCase();
    const dot = path.lastIndexOf('.');
    return dot >= 0 ? path.slice(dot) : '';
  } catch {
    const path = url.split('?')[0].toLowerCase();
    const dot = path.lastIndexOf('.');
    return dot >= 0 ? path.slice(dot) : '';
  }
}

export function isAudioUrl(url = '') {
  const ext = getExt(url);
  return Object.prototype.hasOwnProperty.call(AUDIO_MIME_BY_EXT, ext);
}

export function isImageUrl(url = '') {
  const ext = getExt(url);
  return IMAGE_EXTS.includes(ext);
}

export function resolveMediaType(m) {
  if (m.message_type === 'contact' || m.contact_payload) return 'contact';
  if (m.media_type) return m.media_type;
  if (m.latitude != null && m.longitude != null) return 'location';
  if (m.media_url) {
    if (isAudioUrl(m.media_url)) return 'audio';
    if (isImageUrl(m.media_url)) return 'image';
    const ext = getExt(m.media_url);
    if (['.mp4', '.mov', '.webm'].includes(ext)) return 'video';
    return 'document';
  }
  return null;
}

export function guessAudioMime(url = '') {
  const ext = getExt(url);
  return AUDIO_MIME_BY_EXT[ext] || 'audio/ogg';
}
